/**
 * View (eye) icon permission per list Route.
 * Matches PermissionConfigrations view routes; supports backend name variants.
 */
export const VIEW_ACTION_BY_ROUTE = {
  "/users": "USER_VIEW_ALL||USER_ALL",
  "/application/user-roles": "USER_ROLE_ALL",
  "/client": "VIEW_ORGANIZATION_CLIENT||VIEW_ORGANIZATION_CLIENTS",
  "/client-contact": "VIEW_CLIENT_CONTACTS",
  "/project":
    "VIEW_ORGANIZATION_PROJECT||VIEW_ORGANIZATON_PROJECTS||VIEW_ORGANIZATION_PROJECTS",
  "/project-type": "VIEW_PROJECT_TYPES||VIEW_PROJECT_TYPE",
  "/project-category": "VIEW_PROJECT_CATEGORY",
  "/project-sub-category":
    "VIEW_PROJECT_SUBCATEGORIES||VIEW_PROJECT_SUBCATAGORY",
  "/project-templates": "VIEW_PROJECT_TEMPLATES",
  "/project-templates-milestone": "VIEW_TEMPLATE_MILESTONES",
  "/project-template-tasks": "VIEW_TEMPLATE_TASK||VIEW_TEMPLATE_TASKS",
  "/project-team": "VIEW_PROJECT_TEAMS",
  "/project-team-member": "VIEW_PROJECT_TEAM_MEMBERS",
  "/project-milestone": "VIEW_PROJECT_MILESTONES",
  "/project-task":
    "VIEW_ALL_TASKS||VIEW_TEAM_TASKS||VIEW_INTERN_TASKS",
  "/project-task/interns":
    "VIEW_INTERN_TASKS||VIEW_ALL_TASKS||VIEW_TEAM_TASKS",
  "/project-task-categories": "VIEW_TASK_CATEGORY",
  "/project-task-subcategories": "VIEW_TASK_SUBCATEGORIES",
  "/project-task-schedule": "VIEW_EMPLOYEE_TASK_SCHEDULE",
  "/project-task-schedule/interns": "VIEW_INTERN_TASK_SCHEDULE",
  "/project-task-schedule-timelog": "VIEW_EMPLOYEE_TASK_SCHEDULE_TIMELOGS",
  "/project-task-schedule-timelog/interns":
    "VIEW_INTERN_TASK_SCHEDULE_TIMELOGS",
  "/project-task-recurrence": "VIEW_TASK_RECURRENCES",
  "/project-task-template": "VIEW_TASK_TEMPLATES",
  "/project-task-type": "VIEW_TASK_TYPES",
};

export function resolveViewAction(Route, viewAction) {
  if (viewAction) return viewAction;
  if (!Route) return null;
  return VIEW_ACTION_BY_ROUTE[Route] || null;
}
